import { faUsersSlash, faTelescope } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { EmptyState } from 'components/atoms/empty-state';
import { TeamMembersTabsEnum } from 'components/organisms/module-settings/team-members/types';

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: var(--gray-30);
`;

export const PartnerTeamMemberListEmptyState: FC<{
  viewType: TeamMembersTabsEnum;
}> = ({ viewType }) => {
  return (
    <EmptyState
      image={<StyledFontAwesomeIcon icon={faUsersSlash} size="4x" />}
      title={<FormattedMessage id="partners.team_members.list.empty.title" />}
      message={
        <FormattedMessage
          id={`partners.team_members.list.empty.message.${viewType}`}
        />
      }
    />
  );
};

export const PartnerTeamMemberNoSearchResultState: FC = () => {
  return (
    <EmptyState
      image={<StyledFontAwesomeIcon icon={faTelescope} size="4x" />}
      title={
        <FormattedMessage id="partners.team_members.list.no_search_result.title" />
      }
      message={
        <FormattedMessage id="partners.team_members.list.no_search_result.message" />
      }
    />
  );
};
